import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Form } from 'react-bootstrap';
export var FieldError = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldError, _React$Component);

  var _super = _createSuper(FieldError);

  function FieldError() {
    _classCallCheck(this, FieldError);

    return _super.apply(this, arguments);
  }

  _createClass(FieldError, [{
    key: "render",
    value: function render() {
      var error = this.props.error;
      return React.createElement(Form.Control.Feedback, {
        type: 'invalid'
      }, error);
    }
  }], [{
    key: "isInvalid",
    value: function isInvalid(meta) {
      return meta.error && meta.touched && !meta.active;
    }
  }]);

  return FieldError;
}(React.Component);